// SVG компоненты для устройств

export function PhoneSVG({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 90 160"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Корпус телефона - менее вытянутый */}
      <rect
        x="10"
        y="8"
        width="70"
        height="144"
        rx="10"
        ry="10"
        fill="#1a1a1a"
        stroke="#333"
        strokeWidth="1.5"
      />
      {/* Экран - не закрывает кнопку */}
      <rect
        x="17"
        y="24"
        width="56"
        height="100"
        rx="3"
        ry="3"
        fill="#000"
      />
      {/* Динамик */}
      <ellipse cx="45" cy="18" rx="7" ry="1.5" fill="#333" />
      {/* Кнопка Home - видна под экраном */}
      <circle cx="45" cy="142" r="5" fill="#333" />
      {/* Камера */}
      <circle cx="45" cy="14" r="1.5" fill="#666" />
    </svg>
  );
}

export function TabletSVG({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 300 400"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Корпус планшета */}
      <rect
        x="20"
        y="20"
        width="260"
        height="360"
        rx="15"
        ry="15"
        fill="#1a1a1a"
        stroke="#333"
        strokeWidth="2"
      />
      {/* Экран */}
      <rect
        x="35"
        y="50"
        width="230"
        height="280"
        rx="5"
        ry="5"
        fill="#000"
      />
      {/* Камера */}
      <circle cx="150" cy="35" r="4" fill="#666" />
      {/* Кнопка Home */}
      <circle
        cx="150"
        cy="355"
        r="8"
        fill="#2a2a2a"
        stroke="#444"
        strokeWidth="1"
      />
    </svg>
  );
}

export function LaptopSVG({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 280"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Экран ноутбука */}
      <rect
        x="40"
        y="20"
        width="320"
        height="200"
        rx="5"
        ry="5"
        fill="#000"
        stroke="#333"
        strokeWidth="2"
      />
      {/* Внутренний экран */}
      <rect
        x="50"
        y="30"
        width="300"
        height="180"
        rx="3"
        ry="3"
        fill="#0a0a0a"
      />
      {/* Основание ноутбука */}
      <rect
        x="20"
        y="220"
        width="360"
        height="20"
        rx="3"
        ry="3"
        fill="#1a1a1a"
        stroke="#333"
        strokeWidth="2"
      />
      {/* Тачпад */}
      <rect
        x="150"
        y="225"
        width="100"
        height="10"
        rx="2"
        ry="2"
        fill="#2a2a2a"
      />
    </svg>
  );
}
